import React from 'react';
import OnboardingLayout from 'components/OnboardingLayout';
import { useGlobalState } from 'hooks/useGlobalState';
import styles from './TimeoutScreen.module.scss';

export default function TimeoutScreen() {
  const [{ timeoutScreen }] = useGlobalState();

  return (
    timeoutScreen.visible && (
      <div className={styles.overlay} data-testid="timeoutScreen">
        <OnboardingLayout promptEnabled={false}>
          <div className={styles.imgWrap}>
            <img
              src="/assets/images/timeout-warning.svg"
              alt="Timeout warning"
            />
          </div>
          <h2 className={styles.h2}>
            Something unexpected occurred, but we’re working on it. Please check
            your email for updates.
          </h2>
        </OnboardingLayout>
      </div>
    )
  );
}
